module.exports = __webpack_public_path__ + "static/media/madison.43781379.jpg";